import {
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    FormControl,
    InputLabel,
    Select,
    TextField as InputField,
    MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Button, useDataProvider, useNotify } from "react-admin";

export const SnManagementCreate = ({
    open,
    onClose
}) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [customerTypeChoices, setSaleCustomers] = useState([]);
    const [trafficCustomerId, setTrafficCustomerId] = useState('');

    const [deviceSns, setDeviceSns] = useState('');
    const [strategyId, setStrategyId] = useState('');

    const [inputDeviceSns, setInputDeviceSns] = useState(''); // 新增：用于实时输入

    const [number, setNumber] = useState(0)


    // 重置所有状态
    const resetDialogState = () => {
        setTrafficCustomerId("");
        setStrategyId('');
        setDeviceSns('');
        setInputDeviceSns('');
        fetchNumber()
    };

    const fetchNumber = async () => {
        try {
            const formData = {
                salesCustomerIds: trafficCustomerId,
                deviceSns: deviceSns.split(/[,，]+/)
                    .map(sn => sn.trim())
                    .filter(sn => sn.length > 0),
                strategyId: strategyId
            };
            const res = await dataProvider.countGenTrafficSn(formData);
            setNumber(res.data)
        } catch (error) {
            console.error("获取客户数据失败:", error);
        }
    };

    useEffect(() => {
        fetchNumber()
    }, [strategyId, trafficCustomerId, deviceSns]);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const salesData = await dataProvider.getSalesCustomers();
                setSaleCustomers(salesData.map(item => ({ id: item.id, name: item.name })));
            } catch (error) {
                console.error("获取客户数据失败:", error);
            }
        };

        fetchCustomers();
    }, []);

    useEffect(() => {
        if (open) {
            resetDialogState();
        }
    }, [open]);

    const handleDeviceSnsBlur = () => {
        setDeviceSns(inputDeviceSns);
    };

    const generateTrafficSN = () => {
        if (!trafficCustomerId) {
            notify('请选择设备商家', { type: 'error' });
            return;
        }
        const formData = {
            trafficCustomerId,
            deviceSns: deviceSns.split(/[,，]+/)
                .map(sn => sn.trim())
                .filter(sn => sn.length > 0),
            strategyId
        };
        dataProvider.xunleiGenerateTrafficSN(formData)
            .then(() => {
                notify('生成流量商 SN成功', { type: 'success' });
                onClose(); // 添加这行：生成成功后关闭弹窗
            })
            .catch((error: any) => {
                notify(error.message || '生成流量商 SN失败', { type: 'error' });
            });
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>生成流量SN</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <InputLabel id="traffic-customer-label">设备商家</InputLabel>
                    <Select
                        labelId="traffic-customer-label"
                        value={trafficCustomerId}
                        label="设备商家"
                        onChange={(e) => setTrafficCustomerId(e.target.value)}
                    >
                        <MenuItem value="">请选择设备商家</MenuItem>
                        {customerTypeChoices.map(customer => (
                            <MenuItem key={customer.id} value={customer.id}>
                                {customer.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <InputField
                        label="设备SN"
                        name="inputDeviceSns"
                        value={inputDeviceSns} // 绑定到实时输入状态
                        onChange={(e) => setInputDeviceSns(e.target.value)}
                        onBlur={handleDeviceSnsBlur} // 失去焦点时更新
                        helperText="多个序列号请用逗号分隔"
                        multiline
                        fullWidth
                    />
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <text>统计生成数量:{number}</text>
                </FormControl>


                <FormControl fullWidth margin="normal">
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
                        <Button
                            disabled={number == 0}
                            label="确认生成"
                            color="primary"
                            variant="contained"
                            onClick={generateTrafficSN}
                        />
                    </Box>
                </FormControl>
            </DialogContent>
        </Dialog>
    );
};